export default function formatDate(date) {
  const parts = date.split("-");
  
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
  } else if (parts.length === 2) {
    const [year, month] = parts;
    return `${month}/${year}`;
  }
  
  return date; // Return the original date if it doesn't match expected formats
}